import axios from "axios";
// import * as Sentry from "@sentry/react";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
});

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // // log the entire error object to sentry
    // Sentry.captureException(error);

    // reject the promise with the error response data or a fallback message
    return Promise.reject(error?.response?.data || "Wrong Services");
  }
);

export default axiosServices;
